class SweepBaseVerification {
  constructor() {
    this.baseVerification = new Map();
  }
  set = (id, info) => {//id->baseVerificationId
    this.baseVerification.set(id, info);
  }

  get = (id) => {
    return this.baseVerification.get(id);
  }

  getInterfaces = (id) => {
    const info = this.baseVerification.get(id);
    if (!info || !info.Interfaces || !info.Interfaces.length) {
      return [];
    }
    return info.Interfaces;
  }
}

const sweepBaseVerification = new SweepBaseVerification();

export default sweepBaseVerification;
